import type { AreaComp, GameObj, RotateComp, ScaleComp } from "kaplay";
import { look, lookLabels, type LookComp } from "../components/look";
import { LOOKS, type LookKey } from "../config/assetManifest";
import { k } from "../core/kaplay";
import { missingAssets } from "../core/loader";
import { spin360, squash } from "../core/tweens";
import { viewport } from "../core/viewport";
import { addTitle, addUiRoot } from "../ui/layout";

type Preview = GameObj<LookComp | AreaComp | RotateComp | ScaleComp>;

const ROW_WIDTH = 1800;
const GAP = 48;

function layoutGrid(): Preview[] {
    let x = 0;
    let y = 0;
    let rowHeight = 0;
    return (Object.keys(LOOKS) as LookKey[]).map((key) => {
        const { w, h } = LOOKS[key];
        if (x + w > ROW_WIDTH) {
            x = 0;
            y += rowHeight + GAP;
            rowHeight = 0;
        }
        const obj = k.add([k.pos(x + w / 2, y + h), look(key), k.area(), k.rotate(0), k.scale(1)]);
        x += w + GAP;
        rowHeight = Math.max(rowHeight, h);
        return obj;
    });
}

function nextPose(obj: Preview) {
    const poses = LOOKS[obj.key].poses;
    if (!poses) return;
    obj.pose = poses[(poses.indexOf(obj.pose) + 1) % poses.length];
}

export function assetsScene() {
    lookLabels.visible = true;
    const previews = layoutGrid();
    let selected: Preview = previews[0];
    let zoom = 1;
    let scrollY = 0;

    previews.forEach((obj) =>
        obj.onClick(() => {
            selected = obj;
            nextPose(obj);
        }),
    );

    k.onKeyPress("m", () => (selected.flipX = !selected.flipX));
    k.onKeyPress("r", () => spin360(selected));
    k.onKeyPress("s", () => squash(selected));
    k.onKeyPress("z", () => (zoom = zoom === 1 ? 0.7 : 1));
    k.onKeyDown("down", () => (scrollY += 900 * k.dt()));
    k.onKeyDown("up", () => (scrollY -= 900 * k.dt()));
    k.onScroll((delta) => (scrollY += delta.y));
    k.onKeyPress("escape", () => k.go("menu"));

    k.onUpdate(() => {
        k.setCamScale(viewport.uiScale * zoom);
        k.setCamPos(ROW_WIDTH / 2, viewport.height / 2 - 120 + scrollY);
    });

    const ui = addUiRoot();
    addTitle(ui, "click: next pose · M mirror · R spin · S squash · Z zoom · ↑↓ scroll", 500, 28);
    const status = addTitle(ui, "", -510, 28);
    status.onUpdate(() => {
        status.text = `selected: ${selected.key} ${selected.pose} · zoom ${zoom} · missing files: ${missingAssets.length}`;
    });
}
